import { ROLE_END, ROLE_START,ROLE_GETBY, ROLE_DATA, ROLE_PERMISSION,ROlE_CREATE, ROLE_UPDATE} from "../type";
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL
const loginToken = localStorage.getItem('loginToken')


export const getAllRole = (page:number,size:number) => async (dispatch: Dispatch): Promise<any> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: ROLE_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/api/roles?page=${page}&size=${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: ROLE_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: ROLE_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: ROLE_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};



export const Permission = () => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: ROLE_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/api/roles/permissions`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: ROLE_PERMISSION,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: ROLE_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: ROLE_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};






export const CreateRole = (payload: any) => async (dispatch: Dispatch): Promise<void> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return;
    }
    
    try {
     dispatch({ type: ROLE_START, loading: true,});

      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
      }

      const response = await fetch( `${API_URL}/api/roles`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: ROlE_CREATE,
          payload: res,
          loading: false,
        });
      } else {
        dispatch({
          type: ROLE_END,
          payload: res,
          loading: false,
        });
      }
    } catch (error) {
      dispatch({
        type: ROLE_END,
        payload: error,
        loading: false,
      });
      console.error(error);
    }
  };




  export const getRole = (id: number) => async (dispatch: Dispatch): Promise<any> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return { success: false, message: "Authentication required" };
    }
    
    try {
      dispatch({ type: ROLE_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) throw new Error("Authorization token not found");

      const response = await fetch(
        `${API_URL}/api/roles/${id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: ROLE_GETBY,
          payload: res,
          loading: false,
        });
        return { success: true, data: res };
      } else {
        dispatch({
          type: ROLE_END,
          payload: res,
          loading: false,
        });
        return { success: false };
      }
    } catch (error: any) {
      dispatch({
        type: ROLE_END,
        payload: error.message,
        loading: false,
      });
      return { success: false };
    }
  };




export const UpdateRole = (id:number,payload: any) => async (dispatch: Dispatch): Promise<any> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return { success: false, message: "Authentication required" };
    }
    
    try {
      dispatch({ type: ROLE_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) throw new Error("Authorization token not found");

      const response = await fetch(
        `${API_URL}/api/roles/${id}`,
        {
          method: "PUT", 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: ROLE_UPDATE,
          payload: res,
          loading: false,
        });
        return { success: true, data: res };
      } else {
        dispatch({
          type: ROLE_END,
          payload: res,
          loading: false,
        });
        return { success: false };
      }
    } catch (error: any) {
      dispatch({
        type: ROLE_END,
        payload: error.message,
        loading: false,
      });
      return { success: false, message: error.message };
    }
  };



